import { render, staticRenderFns } from "./AskToBuy.vue?vue&type=template&id=399251e7&scoped=true"
import script from "./AskToBuy.vue?vue&type=script&lang=js"
export * from "./AskToBuy.vue?vue&type=script&lang=js"
import style0 from "./AskToBuy.vue?vue&type=style&index=0&id=399251e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399251e7",
  null
  
)

export default component.exports